/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-04 08:50:00
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import { timer, Subscription } from "rxjs";
import { useStompClient, useStompManager } from "@/frameworks/libraries/network";
import { Configure } from "@/frameworks/libraries/utilities";
import { Properties } from "@/frameworks/libraries/properties";
import { Topics } from "@/frameworks/core/commons";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#useNetworkRPC#";

export default function useNetworkRPC() {
	const network = useStompManager();

	useStompClient({
		onMessageReceived(message) {
			const { type, payload } = message;
			if (payload) {
				switch (type as string) {
					case "myDeskMode": {
						Properties.emit("checkMyDeskMode", payload);
						break;
					}
				}
			}
		}
	});

	const is_my_desk_mode_request = (peerID: string) => {
		return new Promise<boolean>((resolve) => {
			if (!network.isConnected) {
				return resolve(false);
			}
			let timeout: Subscription | null = timer(500).subscribe(() => {
				resolve(false);
				timeout = null;
			});
			Properties.once("checkMyDeskMode", (payload: { mode: boolean }) => {
				if (timeout) {
					timeout.unsubscribe();
					timeout = null;
					resolve(payload.mode);
				}
			});
			network.publish(Topics.ToPeer(peerID), "isMyDeskMode", { userID: Configure.userID, peerID });
		});
	};

	const is_my_desk_mode_response = ({ peerID, userID }: { peerID: string; userID: string }) => {
		if (peerID && peerID === Configure.userID) {
			network.publish(Topics.ToPeer(userID), "myDeskMode", {
				mode: Configure.mydeskMode
			});
		}
		return true;
	};

	const process_rpc_message = (type: string, payload: any) => {
		switch (type) {
			case "isMyDeskMode": {
				return is_my_desk_mode_response(payload);
			}
		}

		return false;
	};

	return {
		isMyDeskMode: is_my_desk_mode_request,
		process_rpc_message
	};
}
